<template>
  <div id="app">
    <tab :activeIndex="activeIndex"></tab>
    <router-view></router-view>
  </div>
</template>

<script>
import tab from "@/components/tab";
export default {
  name: "app",
  components: {
    tab
  },
  watch: {
    $route(to) {
      this.activeIndex = to.name
    }
  },
  data() {
    return {
      activeIndex: this.$route.name
    };
  }
};
</script>

<style lang="scss">
@import "@/assets/css/bass.scss";
</style>
